import { Injectable, inject } from '@angular/core';

import { LDFeatureFlags, LaunchDarklyTrackingService } from '@frontend/sports/launch-darkly/feature';

@Injectable({ providedIn: 'root' })
export class LaunchDarklyAlertsService {
    private readonly launchDarklyTrackingService = inject(LaunchDarklyTrackingService);

    track(flag: LDFeatureFlags, key: string, value: number): void {
        this.launchDarklyTrackingService.trackByLocalStorage(flag, key, undefined, value);
    }
}
